import styled, { keyframes } from 'styled-components';

interface IBackground {
  background?: string;
}

const fade = keyframes`
from {
  opacity: 0;
  transform: translateY(-20px);
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;

const rotate = keyframes`
from {

  transform: rotate(0deg);
}
to{
 
  transform:rotate(180deg);
}
`;

const rotateBack = keyframes`
from {

  transform: rotate(180deg);
}
to{
 
  transform:rotate(360deg);
}
`;

export const Container = styled.div<IBackground>`
  min-height: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: none;
  color: #fff;
  padding: 10px;
  width: 100%;
  max-width: 1000px;

 // border: 2px solid rgb(0,15,64);
  margin: 0px auto;
 
  padding: 30px 20px;

  @media (max-width: 750px) {
    padding: 30px 0px;
  }

  .hover {
    >svg{
     animation: ${fade} 0.5s forwards;
    }
  }

  .projectDiv{
    padding:  0px ;
    display: block ;
    border-radius: 15px;

  }

.searchHeader {
  display: flex ;
  width: 100% ;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;

  h1{
    color: #fff;
    width: 100% ;
  }

  @media (max-width: 750px) {
    margin-bottom: 20px;
    flex-direction: column;
    justify-content: center;
  }
}

  .projectContent{
    padding: 20px;
    width: 100%;

    .projectDate{
      font-size: 14px;
      margin: 0px;
      color: #fff;
    }

    .projectTitle{
      font-size: 16px;
      margin: 5px 0px;
      color: #fff;
    }

    .projectTypeButtons{
      margin-bottom: 10px;
      display: flex ;
      align-items: center;
      justify-content: flex-start;
     
      button {
        margin-right: 5px;
        background: #fff ;
        color: #333;
        font-size: 12px;
        padding: 3px;
        border: 0px;
        border-radius: 5px;
      }

      .online{
        background: rgb(0,100,250) ;
        color: #fff;
      }

      .hibrid{
        background: orange ;
        color: #fff;
      }

      .local{
        background: purple ;
        color: #fff;
      }

      .paid {
        background: rgb(200,100,0);
        color: #fff;
      }

      .free {
        background: rgb(0,150,150);
        color: #fff;
 
      }

      .projectSubscribe{
        background: #fff;
        color: #333;
        font-size: 14px;
        padding: 5px ;
        margin-top: 10px;
      }

      .projectSignIn{
        background: #aaa;
        color: #333;
      }
    }
  }

  .rotateSVGBack {
    >svg{
     animation: ${rotateBack} 0.5s forwards;
    }
  }

  .rotateSVG{
    animation: ${rotate} 0.5s ease-in forwards;
  }

  > h2, >h1 {
    display: flex;
    justify-content: center;
  }

  >h1{
    font-size: 24px;
    margin-top: 20px;

    @media (max-width: 750px) {
      font-size: 18px;
  }
  }

  table {
    width: 100%;
  }

  tr{
    transition: 0.5s all;
    background: rgba(0,15,64,0.8);

    .hourDiv{
      max-width: 140px;
      min-width: 140px;
      @media (max-width: 750px) {
        max-width:85px;
        min-width: 85px;
  }

    }

    .optionDiv{
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: 750px) {
        flex-direction: column;
  }
    }

    &:hover{
      
      background: rgba(0,15,64,0.9);
      box-shadow:  2px 2px 5px rgba(0,0,0,0.9);
    }

    >td {
      padding: 15px 10px !important;
    }
  }

  td { 
    padding: 10px 5px;
  }

  .miniPrograma {
    font-size: 13px;
    font-weight: 400;
    width: 100%;
    margin-top: 5px;

    strong{
      color : rgb(241, 102, 33);
    }
    > figure {
      max-width: 100%;
      margin: 5px 0;
      width: 100%;
      > table {
        width: 100%;
        border-collapse: collapse;
        max-width: 100%;
        > tbody {
          max-width: 100%;
          > tr {
            border: 1px solid #ddd;
            padding: 5px 10px;
            > td {
              font-size: 10px;
              font-weight: 400;
              padding: 3px;
              min-width: 100px;
            }
            > td + td {
              
              width: 100%;
            }
          }
        }
      }
    }
  }

  .programDayHeader {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin-bottom: 15px;
    align-items: center;

    > span {
      min-width: 36px;
    }

    > h2 {
      display: flex;
      justify-content: center;
    }


  }

  @media (max-width: 750px) {
    padding: 5px;
  }

  > table {
    width: 100%;
    border-collapse: collapse;

    > tbody {
      > tr {
        border-top: 1px solid #555;
        padding: 5px 10px;

        > td {
          width: 100%;
          display: flex;
          flex-direction: column;
          padding: 5px 0;
          
          > div {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;

            > a > {
              button {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
`;
